'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _store = require('linksoft/core/store');

var _store2 = _interopRequireDefault(_store);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _message = require('linksoft/message');

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var common = {
    pushHistory: new Event('pushHistory'),
    clearFilter: new Event('clearFilter'),
    createElement: function createElement(tagName, parentElement, params) {
        // Create element helper, to simplify this process
        if (!tagName || !parentElement) return null;

        var element = document.createElement(tagName);
        if (params) {
            (0, _assign2.default)(element, params);
        }
        parentElement.appendChild(element);
        return element;
    },
    getFacetsFromStore: function getFacetsFromStore() {
        var cartBasic = common.getCartBasic();
        return cartBasic ? cartBasic.facets : null;
    },
    getCartData: function getCartData() {
        var cartBasic = common.getCartBasic();
        return cartBasic ? cartBasic.cart : null;
    },
    getCartBasic: function getCartBasic() {
        try {
            var storeData = _store2.default.get();
            return storeData.getState();
        } catch (e) {
            console.error('Cart state was not loaded.', e);
            return null;
        }
    },
    sortByStringParam: function sortByStringParam(array, paramName) {
        var collator = Intl.Collator();

        return array.sort(function (a, b) {
            return collator.compare(a[paramName], b[paramName]);
        });
    },
    replaceDiacriticsCharacters: function replaceDiacriticsCharacters(inputString) {
        var diacriticsChars = "áäčďéěíĺľňóôőöŕšťúůűüýřžÁÄČĎÉĚÍĹĽŇÓÔŐÖŔŠŤÚŮŰÜÝŘŽ";
        var replacements = "aacdeeillnoooorstuuuuyrzAACDEEILLNOOOORSTUUUUYRZ";
        var result = '';
        for (var p = 0; p < inputString.length; p++) {
            var currentChar = inputString.charAt(p);
            var charIndex = diacriticsChars.indexOf(currentChar);
            result += charIndex !== -1 ? replacements.charAt(charIndex) : currentChar;
        }
        return result;
    },
    showMessageOrNotify: function showMessageOrNotify(severity, showAsPopup, title, messageText, options) {
        switch (severity.toLowerCase()) {
            case 'warn':
            case 'warning':
                if (showAsPopup) _message2.default.warn(messageText, title, options);else _notify2.default.warn(messageText, title, options);
                break;
            case 'err':
            case 'error':
            default:
                if (showAsPopup) _message2.default.error(messageText, title, options);else _notify2.default.error(messageText, title, options);
                break;
        }
    },

    batchReplace: function batchReplace(originalText, replacementObject) {
        if (!originalText || !replacementObject || !Array.isArray(replacementObject)) return originalText;

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(replacementObject), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var replacement = _step.value;

                originalText = originalText.replaceAll(replacement.original, replacement.replacement);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return originalText;
    },
    getQueryStringParam: function getQueryStringParam(paramName) {
        return common.getParamFromUrl(document.location.href, paramName);
    },
    getParamFromUrl: function getParamFromUrl(url, paramName) {
        var questionMarkIndex = url.indexOf('?');
        if (questionMarkIndex < -1) return '';

        var queryString = url.substr(questionMarkIndex);

        var rex = new RegExp(paramName + '=[^&]+', 'gi');
        var paramAndValue = rex.exec(queryString);
        if (!paramAndValue || paramAndValue.length < 1) return '';

        return paramAndValue[0].split('=')[1];
    },
    testIntInString: function testIntInString(input) {
        return (/^[0-9]+$/.test(input)
        );
    },

    updateSearchQueryByUrl: function updateSearchQueryByUrl(url) {
        var destElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "#mainContent";

        var data = { ajaxElement: destElement };
        window.history.pushState(data, '', url);
        (0, _store.dispatchAction)((0, _extends3.default)({ type: 'NAVIGATOR/NAVIGATE', uri: url }, data));
        window.dispatchEvent(common.pushHistory);
    },

    setupUpdateSearchUrlByObject: function setupUpdateSearchUrlByObject(filterObject) {
        var filter = filterObject ? '?filter=' + (0, _stringify2.default)(filterObject).substring(1).slice(0, -1) : '';
        return '' + location.origin + location.pathname + filter;
    },

    updateSearchQuery: function updateSearchQuery(currentFilterItemRegex, selectedValues) {
        var filterName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Categories';
        var destElement = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "#mainContent";

        var otherParams = common.getFilterUrlExceptRegex(currentFilterItemRegex);
        if (otherParams) otherParams = ',' + otherParams;
        // call server with url assembled from host and category values from model (selectedCategories)
        var url = '' + location.origin + location.pathname + '?filter="' + filterName + '":[' + selectedValues.map(function (e) {
            return '"' + e + '"';
        }) + ']' + (otherParams || '');
        common.updateSearchQueryByUrl(url, destElement);
    },

    getFilterUrlExceptRegex: function getFilterUrlExceptRegex(currentFilterItemRegex) {
        var filterParam = common.getQueryStringParam('filter');
        if (!filterParam) return null;
        return unescape(filterParam).replace(currentFilterItemRegex, '');
    },

    loadSelectedFiltersFromUrl: function loadSelectedFiltersFromUrl(currentFilterRegex) {
        var filterParam = common.getQueryStringParam('filter');
        if (!filterParam) return [];

        filterParam = unescape(filterParam).match(currentFilterRegex);
        var filterParamMatch = void 0;
        if (!filterParam || filterParam.length < 0 || !(filterParamMatch = filterParam[0].match(/[0-9]+/g))) return [];

        return [].concat((0, _toConsumableArray3.default)(filterParamMatch));
    },

    getFilterParamRegex: function getFilterParamRegex(facetName) {
        return new RegExp("\"?" + facetName + "\"?:\[[0-9\"\',]*\],?", "ig");
    },

    formatIsoDateOnly: function formatIsoDateOnly(date) {
        if (typeof date.toISOString !== 'function') return '';
        var isoString = date.toISOString();
        return isoString && isoString.length > 10 ? isoString.slice(0, 10) : '';
    },

    hideItemPlaceHolderByClass: function hideItemPlaceHolderByClass(addToCartInput, missingInCartRowId) {
        var hiddenCLassName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'missing-in-cart-row-hidden';

        if (!addToCartInput) return;

        var currentPlaceHolder = addToCartInput.closest('tr') || addToCartInput.closest('.products-view-grid>div.item');
        var wrap = addToCartInput.closest('.' + hiddenCLassName);
        if (wrap !== null) return;

        // wrap TR for css styling for odd and even rows
        var wrapper = document.createElement('span'); // cannot be DIV or TR
        currentPlaceHolder.parentNode.insertBefore(wrapper, currentPlaceHolder);
        wrapper.appendChild(currentPlaceHolder);
        wrapper.classList.add(hiddenCLassName);
        wrapper.dataset.missingInCartRowId = missingInCartRowId;
    },

    loadObjectFilter: function loadObjectFilter() {
        var queryStringParamName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'filter';

        try {
            var filterParam = unescape(common.getQueryStringParam(queryStringParamName));
            if (filterParam.endsWith(',')) filterParam = filterParam.slice(0, -1);

            return JSON.parse('{' + filterParam + '}');
        } catch (e) {
            console.error('Error in parsing filter query to JSON.', e);
            return {};
        }
    },

    highLightActiveFilterButton: function highLightActiveFilterButton(isActive, button) {
        if (isActive) button.classList.add('selected-popup-facet');else button.classList.remove('selected-popup-facet');
    },

    getElementPropertySafe: function getElementPropertySafe(selector) {
        var propertyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';

        var element = document.querySelector(selector);
        return element ? element[propertyName] : null;
    },
    setElementPropertySafe: function setElementPropertySafe(selector) {
        var propertyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
        var propertyValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        var element = document.querySelector(selector);
        if (!element) return null;
        element[propertyName] = propertyValue;
        return element;
    },
    setElementDatasetValueSafe: function setElementDatasetValueSafe(selector) {
        var dataSetPropertyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
        var propertyValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        var element = document.querySelector(selector);
        if (!element) return null;
        element.dataset[dataSetPropertyName] = propertyValue;
        return element;
    },
    setListenerSafe: function setListenerSafe(selector, delegate) {
        var eventType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'click';

        var element = document.querySelector(selector);
        if (!element) return null;
        element.addEventListener(eventType, delegate);
        return element;
    },
    convertIntSafe: function convertIntSafe(value) {
        if (!value || typeof value !== 'string') return 0;
        return (/^-?[0-9]{1,10}$/.test(value) ? parseInt(value) : 0
        );
    },
    roundToDecimalPlaces: function roundToDecimalPlaces(value) {
        var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        try {
            if (typeof value !== 'number') {
                console.error('Passed value: \'' + value + '\' is not a number, which can be rounded.');
                return value;
            }
            var multiplier = Math.pow(10, decimalPlaces);
            return Math.round(value * multiplier) / multiplier;
        } catch (e) {
            console.error('Error rounding to specified decimal places of passed value: \'' + value + '\'.', e);
            return value;
        }
    }
};

exports.default = common;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/utils/common.js
// module id = 48
// module chunks = 0 1